var _ = require('underscore');
/**
 * Utility methods for detecting whether Capslock is on.
 *
 * @class capslockDetectorUtils
 * @static
 */

module.exports = {
  /**
   * @param event {jQuery.Event} containing info about the jquery event.
   *   @param event.which {Number} the key that was pressed that triggered this event.
   *   @param event.originalEvent {Event} the original dom browser event that triggered the jquery event.
   * @return {Boolean} true if this is an event that we can detect caps lock on, false otherwise.
   */
  canCapsLockBeDetected: function(event) {
    var keyPressed = String.fromCharCode(event.which);
    var canUseModifierState = _.isFunction(event.originalEvent.getModifierState);
    return keyPressed.toUpperCase() !== keyPressed.toLowerCase() || canUseModifierState;
  },

  /**
   * @param event {jQuery.Event} containing info about the jquery event.
   *   @param event.which {Number} the key that was pressed that triggered this event.
   *   @param event.originalEvent {Event} the original dom browser event that triggered the jquery event.
   *   @param event.shiftKey {Boolean} true if the shift key was pressed as part of this event, false otherwise.
   * @return {Boolean} true if a caps lock state is detected, false otherwise.
   */
  isCapsLockOn: function(event) {
    var capsLockOn = false;
    var canUseModifierState = _.isFunction(event.originalEvent.getModifierState);
    if (canUseModifierState) {
      capsLockOn = event.originalEvent.getModifierState('CapsLock');
    } else {
      var keyPressed = String.fromCharCode(event.which);
      var isUpperCase = keyPressed.toUpperCase() === keyPressed;
      var isLowerCase = keyPressed.toLowerCase() === keyPressed;
      var isShiftPressed = event.shiftKey;
      var capitalLetterNoShift = !isShiftPressed && isUpperCase && !isLowerCase;
      var lowerCaseWithShift = isShiftPressed && !isUpperCase && isLowerCase;
      capsLockOn = capitalLetterNoShift || lowerCaseWithShift;
    }
    return capsLockOn;
  }
};
